import { render, staticRenderFns } from "./loadMore.vue?vue&type=template&id=4c3ddf04"
import script from "./loadMore.vue?vue&type=script&lang=js"
export * from "./loadMore.vue?vue&type=script&lang=js"
import style0 from "./loadMore.vue?vue&type=style&index=0&id=4c3ddf04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports